export default [
    {
        path: "/audit/canteen/stock",
        component: () => import("../Components/List.vue"),
        name: "audit.canteen.stock",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/audit/canteen/stock-test",
        component: () => import("../Components/DemoSheet.vue"),
        name: "audit.canteen.stock.test",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/audit/canteen/assets",
        component: () => import("../Components/Assets.vue"),
        name: "audit.canteen.assets",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/audit/canteen/monthly-sheet",
        component: () => import("../Components/MonthlySheet.vue"),
        name: "audit.canteen.monthly.sheet",
        meta: {
            requiresAuth: true,
        },
    },
];
